/**
 * Option Type Constants
 * These represent different types of options in the assistant flow
 */

/**
 * Window Type - Base product selection (e.g., Standard Window, Arch Window, Bay Window)
 * When optionId is a valid UUID, it represents a product
 */
export const OPTION_TYPE_WINDOW_TYPE = 0;

/**
 * Variation - Product variations and configurations (e.g., frame count, configurations)
 * Always represents product variations
 */
export const OPTION_TYPE_VARIATION = 64;
export const OPTION_TYPE_GLAZING_TYPE = 62;

export const MESSAGE_TYPE_ENUM = {
  user: "user",
  assistant: "assistant",
  priceSurge: "price-surge",
};

export const ACCTION_QUESTION_ID = [
  "Q0126_FINAL",
  "Q0127_FINAL",
  "Q0128_FINAL",
];
export const ALL_OPTION_TYPES: any[] = [
  { label: "Deep Bottom Rails", value: 2 },
  { label: "Horns", value: 3 },
  { label: "Dimension", value: 4 },
  { label: "Transom Drop", value: 5 },
  { label: "Sash", value: 7 },
  { label: "Hardware Colours", value: 9 },
  { label: "Spray", value: 10 },
  { label: "Spray Side", value: 11 },
  { label: "Inside Spray Colour", value: 12 },
  { label: "Outside Spray Colour", value: 13 },
  { label: "Cill Extension", value: 15 },
  { label: "Cill Horns", value: 16 },
  { label: "Welded Cill return", value: 17 },
  { label: "Hardware Item", value: 18 },
  { label: "Cill", value: 21 },
  { label: "Security", value: 22 },
  { label: "Bottom Sash", value: 23 },
  { label: "Top Sash", value: 24 },
  { label: "Place in Head", value: 26 },
  { label: "Place in Sash", value: 27 },
  { label: "Glass Specification", value: 28 },
  { label: "Space Bar", value: 29 },
  { label: "Glazing Pattern", value: 31 },
  { label: "External Foil Colour", value: 34 },
  { label: "Internal Foil colour", value: 35 },
  { label: "Lead Top Sash", value: 36 },
  { label: "Lead Bottom Sash", value: 37 },
  { label: "Arch Top Sash", value: 38 },
  { label: "Arch Bottom Sash", value: 39 },
  { label: "Trickle Vents", value: 40 },
  { label: "Obscure Glazing", value: 41 },
  { label: "Obscure Glazing Placement", value: 42 },
  { label: "Head Extension", value: 44 },
  { label: "Left Jamb", value: 45 },
  { label: "Right Jamb", value: 46 },
  { label: "Weather Bar", value: 47 },
  { label: "Configuration Mode", value: 49 },
  { label: "Head Size", value: 50 },
  { label: "Left Jamb Size", value: 51 },
  { label: "Right Jamb Size", value: 52 },
  { label: "Cill Size", value: 53 },
  { label: "Head Quantity", value: 54 },
  { label: "Left Jamb Quantity", value: 55 },
  { label: "Right Jamb Quantity", value: 56 },
  { label: "Cill Quantity", value: 57 },
  { label: "Numeric Values", value: 58 },
  { label: "Custom Fraction", value: 59 },
  { label: "Profile Colour Type", value: 60 },
  { label: "Hardware Type", value: 61 },
  { label: "Glazing Type", value: 62 },
  { label: "Decorative Bar Type", value: 63 },
  { label: "Variation", value: 64 },
  { label: "D-Handle Position", value: 66 },
  { label: "Putty Line", value: 71 },
  { label: "Coupling Clip", value: 72 },
  { label: "Angled Cill Horn", value: 73 },
  { label: "Angled Cill Horn Size", value: 74 },
  { label: "Decorative Bar Note", value: 75 },
  { label: "Hardware Note", value: 76 },
  { label: "Cill Horn Size", value: 77 },
  { label: "Welded Cill Return Number", value: 78 },
  { label: "Vent Placement", value: 79 },
  { label: "Add-On Face", value: 80 },
];
export const DIMENSION_OPTION = 4;
export const OPTION_TYPE_TRANSOM_DROP = 5;
export const OPTION_TYPE_SASH = 7;
export const OPTION_TYPE_HARDWARE_ITEM = 18;
export const OPTION_TYPE_HARDWARE_TYPE = 61;
export const OPTION_TYPE_DHANDLE_POSITION = 66;
export const OPTION_TYPE_EGRESS_COMPLAINT = 48;
export const OPTION_TYPE_CUSTOM_FRACTION = 59;
export const OPTION_TYPE_NUMERIC_VALUES = 58;
export const OPTION_TYPE_COUPLING_CLIP = 72;
export const OPTION_TYPE_CILL = 21;
export const OPTION_TYPE_SECURITY = 22;
export const OPTION_TYPE_GLASS_SPECIFICATION = 28;
export const OPTION_TYPE_CILL_HORN_SIZE = 77;
export const OPTION_TYPE_ANGLED_CILL_HORN = 73;
export const CILL_HORN_MIN_FOR_ANGLED = 100;

/** Resolver value for the Specials Foil flat surcharge (one-off per quote). */
export const FOIL_SURCHARGE_RESOLVER = 'specials_foil_surchage';
export const OPTION_TYPE_SPRAY = 10;
export const OPTION_TYPE_SPRAY_SIDE = 11;
export const OPTION_TYPE_INSIDE_SPRAY_COLOUR = 12;
export const OPTION_TYPE_OUTSIDE_SPRAY_COLOUR = 13;
export const OPTION_TYPE_FIXING_LUGS = 84;
export const OPTION_TYPE_FITTING_TYPE = 89;
export const OPTION_TYPE_HARDWARE_REQUIRED = 91;
export const OPTION_TYPE_TIMBER_LOOK_JOINTS = 94;
export const BAY_POLES_DEFAULT = 2;
export const BAY_POLES_WITH_ANGLED_CILL = 4;
export const BOTH_SASHES_FIXED_VALUE = 'both_sashes_fixed';

export const EXTERNAL_COLOR_OPTIONS = [34, 9];
export const PROFILE_COLOR_OPTION = 60;
export const FOIL_COLOUR_OPTION_TYPES = new Set([34, 35]);
export const FOIL_CHARGE_BREAKDOWN_LABEL = 'Foil Charge';

export enum ProductStructureType {
    Standard = 1,
    Arch = 2,
    Bays = 3,
    Coupled = 4,
}


export const dbrWindowData = [
  {
    // Left bay window — inner depth visible on the LEFT side
    bay_side: "l",
    perspective_corners: [
      { x: 104, y: 819 }, // Top-Left
      { x: 268, y: 832 }, // Top-Right
      { x: 268, y: 923 }, // Bottom-Right
      { x: 104, y: 902 }, // Bottom-Left
    ],
  },
  {
    // Centre flat window — inner depth visible on BOTH sides
    bay_side: "c",
    perspective_corners: [
      { x: 396, y: 838 }, // Top-Left
      { x: 1138, y: 838 }, // Top-Right
      { x: 1138, y: 938 }, // Bottom-Right
      { x: 396, y: 938 }, // Bottom-Left
    ],
  },
  {
    // Right bay window — inner depth visible on the RIGHT side
    bay_side: "r",
    perspective_corners: [
      { x: 1265, y: 826 }, // Top-Left
      { x: 1428, y: 825 }, // Top-Right
      { x: 1428, y: 901 }, // Bottom-Right
      { x: 1265, y: 923 }, // Bottom-Left
    ],
  },
];